/*
 * @Author: Vanny
 * @Date: 2019-08-01 16:36:12
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-06 16:25:41
 * @Description: 商品管理-仓库
 */
import { call, put, select } from 'redux-saga/effects';
import moment from 'moment';
import { find } from 'lodash';

import { $t } from '../../tools';
import * as goodsApi from '../../services/goodsApi';
import * as constants from '../../config/constants';
import { fewDayAgo } from '../../utils/date';
import { exportToExcelFromNet } from '../../utils';

const initialState = {
  query: {
    days: -1,
    isasc: 0,
    keyword: '',
    order: '',
    disable: 0,
    sday: moment(fewDayAgo(7)),
    eday: moment(),
    page: 1,
    page_num: 50,
    // shop_id: 0,
  },
  list: [],
  pagination: {
    total: 0,
    pageSize: 50,
    current: 1,
  },
  duokeFilter: {
    filters: [],
    radios: [],
  },
  exist: false,
};

export const state = initialState;

export const effects = {
  *getList(action) {
    const state = yield select((state) => state.goodState);
    const { orders, order, ...props } = state.query;
    const query = {
      ...props,
      page_num: state.pagination.pageSize,
      page: state.pagination.current,
    };

    if (orders) query.order = orders;
    else query.order = order;

    yield put({
      type: 'good/fetchCategoryStockWarn',
      payload: query,
    });

    const response = yield call(goodsApi.requestGoodList, query);
    if (response) {
      yield put({
        type: 'good/setState',
        payload: {
          exist: true,
          list: response.list,
          pagination: { ...state.pagination, total: parseInt(response.list_num) },
        },
      });
    }
  },
  /**
   *商品导出
   *
   * @param {*} action
   */
  *exportList({ payload }) {
    const state = yield select((state) => state.goodState);
    const { sday, eday, page, page_num, order, ...params } = state.query;
    let query = {
      ...params,
      order,
      async: '0',
      out: 'excel',
      show_sku: 1,
      ...payload,
      ids: (payload.ids || []).join(),
    };
    if ( ['sales', 'sales_price'].includes(order)) {
      query.sday = moment(sday).format('YYYY-MM-DD')
      query.eday = moment(eday).format('YYYY-MM-DD')
    }
    // 对goods_box进行转换
    if (query.goods_box) {
      const goodsBox = query.goods_box;
      query = { ...query, ...{ [goodsBox]: 1 } };
      delete query.goods_box;
    }
    const title = $t(payload.template_id === '1' ? 'lineup_goods' : 'vertical_goods', 'Import');
    const res = yield call(goodsApi.reqVerticalGoodExport, query);
    if (res) {
      exportToExcelFromNet(res, title);
    }
  },
  // 批量修改商品属性
  *batchSetAttribute(action) {
    yield call(goodsApi.requestGoodAttrBatch, action.payload);
  },

  // 更新分类数量和库存预警数量
  *fetchCategoryStockWarn({ payload }) {
    const appState = yield select((s) => s.appState);
    const res = yield call(goodsApi.requestGoodCategory, payload);
    if (res) {
      yield put({
        type: 'good/transformFilter',
        payload: { warnQuery: res.sys_list.stock_warn, category: res.list, appState },
      });
    }
  },
  // 获取商品详情
  *fetchGoodsDetail({payload}) {
    const res = yield call(goodsApi.reqGoodDetail, payload)
    return res
  }
};

export const reducers = {
  transformFilter(state, action) {
    const {
      appState: {
        attrList,
        attrAliasList,
        attrMap,
        userInfo: { plugins_info: pluginsInfo = [], goods_box: goodsBox = [], shop_list: shopList = [] },
      },
      category,
      warnQuery = 0,
    } = action.payload;
    const goodAttrList = category ? { ...attrList, ...{ category } } : { ...attrList };
    // 系统初始化筛选(分类，年份，季节，品牌等)
    const sysFilters = (shopList.length <= 1
      ? []
      : [
          {
            ...constants.shopFilter,
            options: shopList.map((v) => ({ name: v.name, value: v.id })),
          },
        ]
    ).concat(
      Object.keys(goodAttrList)
        .filter((k) => ['category', 'brand', 'year', 'season'].includes(k))
        .map((key) => {
          const attr = goodAttrList[key];
          const options = attr.map((sub) => {
            // 分类情况要显示具体款数
            if (key === 'category') return { name: sub.name, text: `(${sub.num})`, value: sub.id };
            return { name: sub.name, value: sub.id };
          });
          let attrAlias = {};
          let filter = { code: attrMap[key].type_id_name, options };
          if (key !== 'category') {
            attrAlias = attrAliasList.find(
              (attrAlias) => attrAlias.attr === attrMap[key].type_alias_name
            );
            if (options.length) {
              options.push({ name: $t('unselected', 'TableWrapper'), value: '0' });
            }
          } else {
            const totalNum = attr.reduce((prev, cur) => Number(prev) + Number(cur.num), 0);
            attrAlias = { alias: constants.filterAliasMap[key] };
            filter.text = `(${totalNum})`;
          }

          filter.name = attrAlias?.alias;

          return filter;
        })
    );

    // 商品状态筛选(停用(启用),热卖(非热卖),上架(下架))
    const bhbPlugin = find(pluginsInfo, (sub) => {
      return ['111', '157', '191'].includes(sub.plugins_id);
    });
    const plugin128 = pluginsInfo.find((sub) => sub.plugins_id === '128');
    let statusFilters = constants.goodFilters.statusFilters;
    if (!!bhbPlugin && !!plugin128) {
      statusFilters = statusFilters.concat([
        {
          name: 'hot',
          code: 'hot',
          options: [{ name: 'hot', value: '1' }, { name: 'non_hot', value: '0' }],
        },
        {
          name: 'upper_lower_frames',
          code: 'status',
          options: [{ name: 'upper_frames', value: '1' }, { name: 'lower_frames', value: '2' }],
        },
      ]);
    }

    // 自定义条件筛选
    let cusFilters = JSON.parse(JSON.stringify(constants.goodFilters.cusFilters));
    const plugin136 = pluginsInfo.find((sub) => sub.plugins_id === '136');
    const plugin183 = pluginsInfo.find((sub) => sub.plugins_id === '183');
    if (!!plugin136) {
      cusFilters[0].options = cusFilters[0].options.concat([
        {
          name: 'stock_warn',
          text: `(${warnQuery})`,
          value: 'stock_warn',
        },
      ]);
    }
    const otherFilters = goodsBox
      .filter((g) => g.desc.edit === '1')
      .map((g) => ({ name: g.desc.name, value: g.name }));
    if (!!plugin183) {
      cusFilters = cusFilters.concat([
        {
          name: 'Goods_status',
          code: 'goods_box',
          options: otherFilters,
        },
      ]);
    }
    const filters = sysFilters.concat(statusFilters, cusFilters);
    const radios = filters.map((f) => f.code);

    state.duokeFilter = { filters, radios };

    return { ...state };
  },
};
